import { useParams } from 'next/navigation';
import Typography from 'components/gruenland/atoms/typography';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useCostsData from '../order-payment-section/hooks/useCostsData';
import { CartCostsProps } from '../order-payment-section/types';

const CartCosts: React.FC<CartCostsProps> = ({ className }) => {
  const { locale } = useParams();
  const { loading, costsToRender, total } = useCostsData({ dataReference: 'cart' });
  return (
    <div className={className}>
      <div className="grid gap-2">
        {costsToRender.map(
          ({ key, label, value }) =>
            !!value?.centAmount &&
            value.centAmount > 0 && (
              <div key={key} className="flex items-center justify-between capitalize text-secondary-black">
                <Typography asSkeleton={loading}>{label}</Typography>
                <Typography asSkeleton={loading}>{CurrencyHelpers.formatForCurrency(value, locale)}</Typography>
              </div>
            ),
        )}
      </div>
      <div className="mt-6 flex items-center justify-between font-medium">
        <Typography asSkeleton={loading}>{total.label}</Typography>
        <Typography asSkeleton={loading}>{CurrencyHelpers.formatForCurrency(total.value, locale)}</Typography>
      </div>
    </div>
  );
};

export default CartCosts;
